export default "__VITE_ASSET__pvpIMbh0__"